(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (() => {
    const syncCategoryFilterLinks = () => {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.delete('page');
      searchParams.delete('section_id');

      const queryString = searchParams.toString();
      const currentPath = window.location.pathname;

      document.querySelectorAll('[data-category-base-url]').forEach((link) => {
        const baseUrl = link.dataset.categoryBaseUrl;

        if (!baseUrl) return;

        const targetUrl = new URL(baseUrl, window.location.origin);
        const targetPath = targetUrl.pathname;

        link.href = queryString ? `${targetPath}?${queryString}` : targetPath;

        if (targetPath === currentPath) {
          link.classList.add('theme14plus-category-switcher__link--active');
          link.setAttribute('aria-current', 'page');
        } else {
          link.classList.remove('theme14plus-category-switcher__link--active');
          link.removeAttribute('aria-current');
        }
      });
    };

    document.addEventListener('DOMContentLoaded', syncCategoryFilterLinks);
    document.addEventListener('theme14plus:product-grid-updated', syncCategoryFilterLinks);
    window.addEventListener('popstate', syncCategoryFilterLinks);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('recently-viewed-products')) {
    class RecentlyViewedProducts extends HTMLElement {
      static STORAGE_KEY = 'recently-viewed-products';
      static MAX_STORED = 20;
      static MAX_DISPLAY = 4;

      connectedCallback() {
        this.currentHandle = this.dataset.currentHandle;
        this.grid = this.querySelector('ul');
        this.saveCurrentHandle();
        this.render();
      }

      getStoredHandles() {
        try {
          return JSON.parse(localStorage.getItem(RecentlyViewedProducts.STORAGE_KEY)) || [];
        } catch {
          return [];
        }
      }

      setStoredHandles(handles) {
        try {
          localStorage.setItem(RecentlyViewedProducts.STORAGE_KEY, JSON.stringify(handles));
        } catch {
          // Storage unavailable or quota exceeded
        }
      }

      saveCurrentHandle() {
        if (!this.currentHandle) return;

        const handles = this.getStoredHandles().filter(
          (handle) => handle !== this.currentHandle
        );
        handles.unshift(this.currentHandle);
        this.setStoredHandles(handles.slice(0, RecentlyViewedProducts.MAX_STORED));
      }

      async render() {
        const handles = this.getStoredHandles()
          .filter((handle) => handle !== this.currentHandle)
          .slice(0, RecentlyViewedProducts.MAX_DISPLAY);

        if (handles.length === 0) {
          this.closest('section').style.display = 'none';
          return;
        }

        const results = await Promise.all(
          handles.map((handle) => this.fetchProduct(handle))
        );
        const products = results.filter((product) => product !== null);

        if (products.length === 0) {
          this.closest('section').style.display = 'none';
          return;
        }

        this.grid.innerHTML = products
          .map(
            (product) =>
              `<li class="grid__item">${this.buildCardHTML(product)}</li>`
          )
          .join('');
      }

      async fetchProduct(handle) {
        try {
          const response = await fetch(`/products/${handle}.js`);
          return await response.json();
        } catch {
          return null;
        }
      }

      buildCardHTML(product) {
        const title = RecentlyViewedProducts.escapeHTML(product.title);
        const url = `/products/${product.handle}`;
        const image = product.featured_image;
        const isSale =
          product.compare_at_price > product.price;
        const price = `&yen;${Math.floor(product.price / 100).toLocaleString('ja-JP')}`;
        const compareAtPrice = isSale
          ? `&yen;${Math.floor(product.compare_at_price / 100).toLocaleString('ja-JP')}`
          : '';

        const imageHTML = image
          ? `<div class="card__media">
              <div class="media media--transparent">
                <img
                  src="${RecentlyViewedProducts.resizeImage(image, 533)}"
                  srcset="${RecentlyViewedProducts.buildSrcset(image)}"
                  sizes="(min-width: 990px) 25vw, 50vw"
                  alt="${title}"
                  loading="lazy"
                  width="533"
                  height="600"
                >
              </div>
            </div>`
          : '';

        const saleBadgeHTML = isSale
          ? `<span class="badge badge--bottom-left">セール中</span>`
          : '';

        const compareAtPriceHTML = isSale
          ? `<s class="price-item price-item--regular">${compareAtPrice}</s>`
          : '';

        const priceClass = isSale ? ' price--on-sale' : '';

        return `<div class="card-wrapper product-card-wrapper underline-links-hover">
          <div class="card card--standard${image ? ' card--media' : ' card--text'}" style="--ratio-percent: 100%;">
            <div class="card__inner color-scheme-1 gradient ratio" style="--ratio-percent: 100%;">
              ${imageHTML}
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h5">
                  <a href="${url}" class="full-unstyled-link">${title}</a>
                </h3>
                <div class="card-information">
                  <div class="price${priceClass}">
                    <div class="price__container">
                      ${compareAtPriceHTML}
                      <span class="price-item price-item--sale">${price}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card__badge">
                ${saleBadgeHTML}
              </div>
            </div>
          </div>
        </div>`;
      }

      static escapeHTML(text) {
        const div = document.createElement('div');
        div.appendChild(document.createTextNode(text));
        return div.innerHTML;
      }

      static resizeImage(src, width) {
        return src.replace(/(\.[^.?]+)(\?.*)?$/, (_, ext, query) => `_${width}x${ext}${query || ''}`);
      }

      static buildSrcset(src) {
        return [165, 360, 533, 720]
          .map((w) => `${RecentlyViewedProducts.resizeImage(src, w)} ${w}w`)
          .join(', ');
      }
    }

    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["theme14plus-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.dispatchEvent(new CustomEvent('theme14plus:close-header-panels', { bubbles: true }));
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (() => {
    const shell = document.querySelector('.theme14plus-header-shell');
    if (!shell) return;

    const desktopSearchToggle = shell.querySelector('[data-theme14plus-desktop-search-toggle]');
    const desktopSearch = shell.querySelector('[data-theme14plus-desktop-search]');
    const desktopSearchCloseButtons = shell.querySelectorAll('[data-theme14plus-desktop-search-close]');
    const desktopSearchInput = desktopSearch?.querySelector('input[type="search"]');
    const desktopPanels = shell.querySelector('[data-theme14plus-desktop-panels]');
    const desktopPanelButtons = shell.querySelectorAll('[data-theme14plus-desktop-panel-trigger]');
    const desktopPanelCloseButtons = shell.querySelectorAll('[data-theme14plus-desktop-panel-close]');
    const desktopPanelItems = shell.querySelectorAll('[data-theme14plus-desktop-panel]');
    const mobileMenu = shell.querySelector('[data-theme14plus-mobile-menu]');
    const mobileMenuOpenButtons = shell.querySelectorAll('[data-theme14plus-mobile-menu-open]');
    const mobileMenuCloseButtons = shell.querySelectorAll('[data-theme14plus-mobile-menu-close]');
    const mobileSearchPanel = shell.querySelector('[data-theme14plus-mobile-search]');
    const mobileSearchFocus = shell.querySelector('[data-theme14plus-mobile-search-focus]');
    const mobileSearchCloseButtons = shell.querySelectorAll('[data-theme14plus-mobile-search-close]');
    const mobileSearchInput = shell.querySelector('#Theme14PlusMobileSearch');
    const accordionGroups = shell.querySelectorAll('[data-theme14plus-accordion]');

    const closeDesktopSearch = () => {
      shell.dataset.desktopSearchOpen = 'false';
      if (desktopSearch) desktopSearch.hidden = true;
      desktopSearchToggle?.setAttribute('aria-expanded', 'false');
    };

    const openDesktopSearch = () => {
      shell.dataset.desktopSearchOpen = 'true';
      if (desktopSearch) desktopSearch.hidden = false;
      desktopSearchToggle?.setAttribute('aria-expanded', 'true');
      closeDesktopPanels();
      requestAnimationFrame(() => desktopSearchInput?.focus());
    };

    const closeDesktopPanels = () => {
      shell.dataset.desktopPanelActive = 'false';
      if (desktopPanels) desktopPanels.hidden = true;
      desktopPanelItems.forEach((panel) => panel.classList.remove('is-active'));
      desktopPanelButtons.forEach((button) => {
        button.classList.remove('is-active');
        button.setAttribute('aria-expanded', 'false');
      });
    };

    const openDesktopPanel = (panelId) => {
      closeDesktopSearch();
      shell.dataset.desktopPanelActive = 'true';
      if (desktopPanels) desktopPanels.hidden = false;

      desktopPanelItems.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.theme14plusDesktopPanel === panelId);
      });

      desktopPanelButtons.forEach((button) => {
        const isActive = button.dataset.theme14plusDesktopPanelTrigger === panelId;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });
    };

    const closeMobileMenu = () => {
      shell.dataset.mobileMenuOpen = 'false';
      if (mobileMenu) mobileMenu.hidden = true;
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    };

    const closeMobileSearch = () => {
      shell.dataset.mobileSearchOpen = 'false';
      if (mobileSearchPanel) mobileSearchPanel.hidden = true;
      mobileSearchFocus?.setAttribute('aria-expanded', 'false');
    };

    const openMobileSearch = () => {
      shell.dataset.mobileSearchOpen = 'true';
      if (mobileSearchPanel) mobileSearchPanel.hidden = false;
      mobileSearchFocus?.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => mobileSearchInput?.focus());
    };

    const openMobileMenu = () => {
      closeMobileSearch();
      shell.dataset.mobileMenuOpen = 'true';
      if (mobileMenu) mobileMenu.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    };

    desktopSearchToggle?.addEventListener('click', () => {
      if (shell.dataset.desktopSearchOpen === 'true') {
        closeDesktopSearch();
      } else {
        openDesktopSearch();
      }
    });

    desktopSearchCloseButtons.forEach((button) => {
      button.addEventListener('click', closeDesktopSearch);
    });

    desktopPanelButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const panelId = button.dataset.theme14plusDesktopPanelTrigger;
        const isAlreadyActive = button.classList.contains('is-active') && shell.dataset.desktopPanelActive === 'true';

        if (isAlreadyActive) {
          closeDesktopPanels();
          return;
        }

        openDesktopPanel(panelId);
      });
    });

    desktopPanelCloseButtons.forEach((button) => {
      button.addEventListener('click', closeDesktopPanels);
    });

    mobileMenuOpenButtons.forEach((button) => {
      button.addEventListener('click', openMobileMenu);
    });

    mobileMenuCloseButtons.forEach((button) => {
      button.addEventListener('click', closeMobileMenu);
    });

    mobileSearchFocus?.setAttribute('aria-expanded', 'false');

    mobileSearchFocus?.addEventListener('click', () => {
      if (shell.dataset.mobileSearchOpen === 'true') {
        closeMobileSearch();
      } else {
        closeMobileMenu();
        openMobileSearch();
      }
    });

    mobileSearchCloseButtons.forEach((button) => {
      button.addEventListener('click', closeMobileSearch);
    });

    accordionGroups.forEach((group) => {
      const trigger = group.querySelector('[data-theme14plus-accordion-trigger]');
      trigger?.addEventListener('click', () => {
        const isOpen = group.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    const closeAllInteractivePanels = () => {
      closeDesktopSearch();
      closeDesktopPanels();
      closeMobileSearch();
      closeMobileMenu();
    };

    shell.addEventListener('theme14plus:close-header-panels', closeAllInteractivePanels);

    document.addEventListener('click', (event) => {
      if (!shell.contains(event.target)) {
        closeAllInteractivePanels();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAllInteractivePanels();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990) {
        closeMobileMenu();
      } else {
        closeDesktopSearch();
        closeDesktopPanels();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
